import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/mdf/funds/:fundId/allocations
//
// Replaces /app/admin/mdf/_actions.ts::createAllocationAction. Pessimistic.
// The fundId is on the URL (per the route shape); the request body carries
// the partner_id + cap + notes. The route handler stitches fundId from the
// URL into the body before validating, so callers pass `partner_id` only
// in `input`.
type Vars = {
  fundId: string;
  input: { partner_id: string; cap_amount_eur: number; notes?: string | null };
};

export function useCreateAllocation() {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, Vars>({
    mutationFn: ({ fundId, input }) =>
      apiFetch<{ id: string }>(`/admin/mdf/funds/${fundId}/allocations`, {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: (_data, { fundId }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.fund(fundId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create allocation");
    },
  });
}
